package com.essntl.features.invoice.ui.addeditinvoice.components.content.extraservice

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.essntl.core.utils.utils.pluralize
import com.essntl.features.invoice.ui.addeditinvoice.AddEditInvoiceState
import com.essntl.features.invoice.ui.addeditinvoice.components.ExpandCollapseArrowWithText
import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel
import com.essntl.uikit.components.utils.EsModifiers.LargeSectionModifier
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun InvoicingExtraServiceSection(
    state: AddEditInvoiceState,
    onRemoveExtraService: (ExtraServiceModel) -> Unit,
) {
    var isExpanded by remember { mutableStateOf(true) }

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = LargeSectionModifier,
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Text(
                text = "Extra services",
                style = MaterialTheme.esTypography.h4SemiBold20,
                color = MaterialTheme.esColorScheme.textPrimary,
            )

            Spacer(modifier = Modifier.weight(1f))

            ExpandCollapseArrowWithText(
                text = state.extraServiceList.data
                    .orEmpty()
                    .size
                    .pluralize("service"),
                isExpanded = isExpanded,
                onToggleExpanded = {
                    isExpanded = !isExpanded
                },
            )
        }

        AnimatedVisibility(
            visible = isExpanded,
            modifier = Modifier
                .fillMaxWidth(),
        ) {
            Column(
                horizontalAlignment = Alignment.CenterHorizontally,
                verticalArrangement = Arrangement.spacedBy(2.spacing),
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(top = 3.spacing),
            ) {
                state.extraServiceList.data.orEmpty().forEach { extraService ->
                    ExtraServiceItem(
                        extraService = extraService,
                        onRemove = { onRemoveExtraService(extraService) },
                        modifier = Modifier.fillMaxWidth(),
                    )
                }
            }
        }
    }
}